import backface from './backface.js';
import delay from './delay.js';
import direction from './direction.js';
import duration from './duration.js';
import enterleave from './enterleave.js';
import fillMode from './fillMode.js';
import iterationCount from './iterationCount.js';
import playState from './playState.js';
import preset from './preset.js';
import timingFunction from './timingFunction.js';

export default {
    backface,
    delay,
    direction,
    duration,
    enterleave,
    fillMode,
    iterationCount,
    playState,
    preset,
    timingFunction
};
